import { noop } from "lodash";
import type { PreviewComponents } from "../../../types";
import { InstallmentsLines } from "../InstallmentsLines";

export const installmentsVariant: PreviewComponents = [
  [InstallmentsLines.HeaderLine, noop],
  [InstallmentsLines.RegularPriceLine, noop],
  [InstallmentsLines.DiscountLine, noop],
  [InstallmentsLines.TaxLine, noop],
  // Next monthly payment on
  // One time payment on
  [InstallmentsLines.SubtotalLine, noop],
];
